import {all, call, put, takeEvery} from "redux-saga/effects";
import cityApi from "@api/city";
import {
  CitiesActionTypes, fetchError, fetchSuccess, createError, createSuccess, deleteError, deleteSuccess,
  updateSuccess, updateError, fetchItemSuccess, fetchItemError
} from "@actions/city";
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(cityApi.getList, payload);
    yield put(fetchSuccess(res));
  }
  catch (err) {
    yield put(fetchError(err));
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(cityApi.delete, payload);
    yield put(deleteSuccess(payload));
  }
  catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(cityApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data))
  }
  catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(cityApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data))
  }
  catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleFetchItem({payload}: ReduxAction) {
  try {
    const {data} = yield call(cityApi.getItem, payload);
    yield put(fetchItemSuccess(data))
  }
  catch (err) {
    yield put(fetchItemError(err))
  }
}


/*************************************************************
 **************************************************************/


function* citiesSaga() {
  yield all([
    yield takeEvery(CitiesActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(CitiesActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(CitiesActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(CitiesActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(CitiesActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
  
  ])
}

export default citiesSaga
